
import { Component, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { CustomizerColorsAutoUpdateComponent, CustomizerComponentHeaderComponent } from '@app/customizer/components';
import { PreciousMetalInfoComponent } from '@app/customizer/components/precious-metal-info/precious-metal-info.component';
import { ConfigurationService } from '@services/configuration.service';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ComponentVariantModel } from '@models/component-variant';
import { VariantColorModel } from '@models/variant-color';
import { DataApiService } from '@services/data-api.service';
import { EventsService } from '@services/events.service';
import { ComponentVariantChangeModel } from '../../../../_models/component-variant-change';
import { BaseCustomizerComponent } from './../../../../shared/base-customizer-component';

@Component({
    template: `
    <customizer-component-header [menu]="menu" (updateCollapsedOnComponent)="updateCollapsed($event)">
      @if (selectableVariants.length) {
        <customizer-colors-auto-update
          [selected]="getSelectedVariant.VariantColor"
          [selectedColorGroup]="currentColorGroup"
          [variants]="selectableVariants"
          [editMode]="state === customizerStateEnum.EDITORDER"
          [matchableColors]="matchableColors"
          [useColorGroup]="menu.contentGrouping"
          (colorMatchChange)="matchColors($event)"
          (selectedColorGroupChange)="onSelectGroup($event)"
          (selectedColorChange)="onSelect($event)"
          [(scrollPosition)]="menu.menuDetails.scrollPosition"
          [variantOrModelIsNew]="variantOrModelIsNew"
          [matchColor]="menu.matchColor"
          >
        </customizer-colors-auto-update>
      }
    </customizer-component-header>
    <precious-metal-info [selectedVariant]="getSelectedVariant" [modelGroup]="modelGroup"></precious-metal-info>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PreciousMetalInfoComponent, CustomizerComponentHeaderComponent, CustomizerColorsAutoUpdateComponent]
})
export class FrontColorComponent extends BaseCustomizerComponent {

	selectableVariants: Array<ComponentVariantFromApiModel> = [];

	constructor(
		public override events: EventsService,
		public apiService: DataApiService,
		public override configurationService: ConfigurationService
	) {
		super(events, apiService, configurationService);
	}

	async initData() {
		this.events.showLoader(true);

		this.selectableVariants = await this.fetchData() ?? [];

		this.events.showLoader(false);
	}

	onChanges(changes: SimpleChanges): void {
	}

	async fetchData(): Promise<Array<ComponentVariantFromApiModel> | undefined> {
		const variant = this.getSelectedVariant;
		variant.VariantColorViewed = true;

		const apidata = await this.configurationService.getVariants(this.configuration?.ModelConfigurationUuid, this.modelGroup, undefined, variant.Uuid, variant.VariantSize?.Uuid);
		await this.RunDisablingSystem(apidata);
		return apidata;
	}

	onSelect(color: VariantColorModel) {
		this.events.showLoader(true);

		const newVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		const oldVariant = Object.assign(new ComponentVariantModel(this.getSelectedVariant.Discontinued, this.getSelectedVariant.New), this.getSelectedVariant);
		newVariant.VariantColor = color;
		this.updateVariant(new ComponentVariantChangeModel(oldVariant, newVariant, null));
	}

}
